module.exports = __webpack_public_path__ + "img/ftp_login.fc11b35a.png";